import {createApi} from "@reduxjs/toolkit/query/react"
import {
    ReviewDetailedRequest,
    ReviewDetailedResponse,
    ReviewListRequest,
    ReviewListResponse,
    ReviewStatisticsRequest,
    ReviewStatisticsResponse
} from "./ReviewApiTypes"
import baseQuery from "../../utils/apiIIKOConfig"

export const reviewsApi = createApi({
    reducerPath: "reviewsApi",
    baseQuery,
    endpoints: (builder) => ({
        fetchReviews: builder.mutation<ReviewListResponse, ReviewListRequest>({
            query: (body) => ({
                url: "v1/reviews/list",
                method: "POST",
                headers: {
                    "X-Time-Zone": "Asia/Tashkent"
                },
                body
            })
        }),
        fetchReviewStatistics: builder.mutation<ReviewStatisticsResponse, ReviewStatisticsRequest>({
            query: (body) => ({
                url: "v1/reviews/statistics",
                method: "POST",
                headers: {
                    "X-Time-Zone": "Asia/Tashkent"
                },
                body
            })
        }),
        getReviewDetailed: builder.query<ReviewDetailedResponse, ReviewDetailedRequest>({
            query: ({id}) => ({
                url: `v1/reviews/${id}/detailed`,
                method: "GET",
                headers: {
                    "X-Time-Zone": "Asia/Tashkent"
                }
            })
        })
    })
})

export const {useFetchReviewsMutation, useFetchReviewStatisticsMutation, useLazyGetReviewDetailedQuery} = reviewsApi
